import angular from 'angular';
import {
  ssDialogService,
} from 'app/services';

import template from './material-change-dialog.html';
import controller from './material-change-dialog.controller';
import explanationTpl from './messages/explanation.messages.html';

class dialogService {
  getOptions({ callback }) {
    return {
      controller,
      controllerAs: 'materialChangeDialogVM',
      locals: {
        callback
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.materialChangeDialog', [
  ssDialogService,
])
  .service('materialChangeDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('explanation.messages.html', explanationTpl);
  })
  .name;
